import type { Class, ClassApi, Classes, ClassesApi, ClassFilters, ClassFiltersUpdateApi } from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizeClass = (freightClass: ClassApi): Class => ({
  ...freightClass,
  id: freightClass.codeId ?? String(freightClass.id),
  label: freightClass.codeDesc,
});

export const normalizeClasses = (response: ClassesApi): Classes => {
  const list = (response.items ?? []).map(normalizeClass);
  return {
    list,
    map: list.reduce(
      (acc, freightClass) => {
        acc[String(freightClass.id)] = freightClass;
        return acc;
      },
      {} as Classes['map'],
    ),
  };
};

export const normalizeClassFilters = (filters: Partial<ClassFilters>): ClassFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'codeDesc asc',
  };
};
